import { ID } from '@adornis/baseql/baseqlTypes.js';
import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { authenticatedMiddleware } from '../../permissions/middlewares/authenticatedMiddleware.js';
import { FamilyRelative } from './FamilyRelative.js';
import { resolveGetPersonRelations } from './server/resolveGetPersonRelations.js';

/** the resolver checks `VIEW_PROFILE` on the person and decides per relative what goes out */
const getPersonRelations = registerQuery({
  operationName: 'getPersonRelations',
  type: () => [FamilyRelative],
  params: [{ type: () => ID, name: 'personID' }],
  // the card refetches after an edit - a cached answer would show the link that was just removed
  options: { requestHandlerMeta: { queryCache: { cachePolicy: 'bypass' } } },
  middlewares: [authenticatedMiddleware],
  resolve: resolveGetPersonRelations,
});

export const FamilyAPI = {
  getPersonRelations,
};
